/*
 * サブシステム名：マスタ管理
 * 機能名：定型コース一覧
 * package版
 */

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdDropDown = () => import('@/components/DdDropDown')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSwitch = () => import('@/components/DdSwitch')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'MstTeikeiCorceListVerPackage',
  mixins: [flowMixin],
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      teikeiCourseNo: '',
      teikeiCourseNm: '',
      tokuisakiCd: '',
      chumonNo: '',
      ohfukuSbt: '',
      seikyuShashuSbt: '',
      tantoEigyoshoCd: '',
      hatsuchiCd: '',
      chakuchiCd: ''
    },
    mstEigyoshoHeader: header.mstEigyoshoHeaders,
    mstTorihikisakiHeader: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    modeKengen: 0
  }),
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdDataTable,
    DdDefaultButton,
    DdDropDown,
    DdFooterButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdSubHeader,
    DdSwitch,
    DdTextBox
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        if (elem.tokuisakiId) { elem.tokuisakiDisp = elem.tokuisakiCd + ' : ' + elem.tokuisakiNm }
        elem.hinmeiDisp = elem.mstHinmeiId ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        elem.hatsuchiDisp = elem.hatsuchiId ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.chakuchiDisp = elem.chakuchiId ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.keiyuchiId1Disp = elem.keiyuchiId1 ? elem.keiyuchiId1Cd + ' : ' + elem.keiyuchiId1Nm : elem.keiyuchiId1Biko
        elem.keiyuchiId2Disp = elem.keiyuchiId2 ? elem.keiyuchiId2Cd + ' : ' + elem.keiyuchiId2Nm : elem.keiyuchiId2Biko
        elem.keiyuchiId3Disp = elem.keiyuchiId3 ? elem.keiyuchiId3Cd + ' : ' + elem.keiyuchiId3Nm : elem.keiyuchiId3Biko
        elem.keiyuchiId4Disp = elem.keiyuchiId4 ? elem.keiyuchiId4Cd + ' : ' + elem.keiyuchiId4Nm : elem.keiyuchiId4Biko
        elem.keiyuchiId5Disp = elem.keiyuchiId5 ? elem.keiyuchiId5Cd + ' : ' + elem.keiyuchiId5Nm : elem.keiyuchiId5Biko
        if (elem.tantoEigyoshoId) { elem.tantoEigyoshoDisp = elem.tantoEigyoshoCd + ' : ' + elem.tantoEigyoshoNm }
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : elem.hatsuchiHmsBiko
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : elem.chakuchiHmsBiko
        elem.yoteiSokoKyoriDisp = elem.yoteiSokoKyori ? filter.numericFormatter(elem.yoteiSokoKyori) + ' km' : null
        elem.yoteiSagyoJikanDisp = elem.yoteiSagyoJikan ? filter.minToIntervalTimeFormatter(elem.yoteiSagyoJikan) : null
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericFormatter(elem.juchuSuryo) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericFormatter(elem.juchuJuryo) }
        if (elem.tanka) { elem.tanka = filter.numericFormatter(elem.tanka) }
        if (elem.kihonUnchin) { elem.kihonUnchin = filter.numericFormatter(elem.kihonUnchin) }
        if (elem.hiwayPrice) { elem.hiwayPrice = filter.numericFormatter(elem.hiwayPrice) }
        if (elem.unchinHokaKingaku) { elem.unchinHokaKingaku = filter.numericFormatter(elem.unchinHokaKingaku) }
        if (elem.hokanKingaku) { elem.hokanKingaku = filter.numericFormatter(elem.hokanKingaku) }
        if (elem.niekiKingaku) { elem.niekiKingaku = filter.numericFormatter(elem.niekiKingaku) }
        if (elem.unchinHokaHikazei) { elem.unchinHokaHikazei = filter.numericFormatter(elem.unchinHokaHikazei) }
        if (elem.tatekaekinHikazei) { elem.tatekaekinHikazei = filter.numericFormatter(elem.tatekaekinHikazei) }
        if (elem.nenryoSurcharge) { elem.nenryoSurcharge = filter.numericFormatter(elem.nenryoSurcharge) }
        if (elem.tsumikomiKingaku) { elem.tsumikomiKingaku = filter.numericFormatter(elem.tsumikomiKingaku) }
        if (elem.torioroshiKingaku) { elem.torioroshiKingaku = filter.numericFormatter(elem.torioroshiKingaku) }
        elem.taikiJikanDisp = elem.taikiJikan ? filter.minToIntervalTimeFormatter(elem.taikiJikan) : null
        if (elem.taikiJikanTanka) { elem.taikiJikanTanka = filter.numericFormatter(elem.taikiJikanTanka) }
        if (elem.taikiJikanKingaku) { elem.taikiJikanKingaku = filter.numericFormatter(elem.taikiJikanKingaku) }
        if (elem.futaiGyomuKingaku) { elem.futaiGyomuKingaku = filter.numericFormatter(elem.futaiGyomuKingaku) }
        elem.warimashiTaishoJikanDisp = elem.warimashiTaishoJikan ? filter.minToIntervalTimeFormatter(elem.warimashiTaishoJikan) : null
        if (elem.warimashiJikanTanka) { elem.warimashiJikanTanka = filter.numericFormatter(elem.warimashiJikanTanka) }
        elem.warimashiTaishoKyoriDisp = elem.warimashiTaishoKyori ? filter.numericFormatter(elem.warimashiTaishoKyori) + ' km' : null
        if (elem.warimashiKyoriTanka) { elem.warimashiKyoriTanka = filter.numericFormatter(elem.warimashiKyoriTanka) }
        if (elem.jikanWarimashiKingaku) { elem.jikanWarimashiKingaku = filter.numericFormatter(elem.jikanWarimashiKingaku) }
        if (elem.kyoriWarimashiKingaku) { elem.kyoriWarimashiKingaku = filter.numericFormatter(elem.kyoriWarimashiKingaku) }
        if (elem.warimashiSonotaKingaku) { elem.warimashiSonotaKingaku = filter.numericFormatter(elem.warimashiSonotaKingaku) }
        if (elem.seikyuGokei) { elem.seikyuGokei = filter.numericFormatter(elem.seikyuGokei) }
        if (elem.yoshaUnchin) { elem.yoshaUnchin = filter.numericFormatter(elem.yoshaUnchin) }
        if (elem.yoshaHiwayPrice) { elem.yoshaHiwayPrice = filter.numericFormatter(elem.yoshaHiwayPrice) }
        if (elem.sagyoinTeateKingaku1) { elem.sagyoinTeateKingaku1 = filter.numericFormatter(elem.sagyoinTeateKingaku1) }
        if (elem.sharyoKeihiHiwayEtc) { elem.sharyoKeihiHiwayEtc = filter.numericFormatter(elem.sharyoKeihiHiwayEtc) }
        if (elem.sharyoKeihiHiwayGenkin) { elem.sharyoKeihiHiwayGenkin = filter.numericFormatter(elem.sharyoKeihiHiwayGenkin) }
        if (elem.sharyoKeihiFerry) { elem.sharyoKeihiFerry = filter.numericFormatter(elem.sharyoKeihiFerry) }
        return elem
      }).sort((a, b) => {
        if (a.teikeiKihonNo > b.teikeiKihonNo) { return 1 }
        if (a.teikeiKihonNo === b.teikeiKihonNo) { return 0 }
        return -1
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      shubetsuList: 'DDMasters/mstShubetsu'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地マスタフィルター <-- ここまで
    // 品名
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 往復種別フィルター
    filteredOhfukuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT006')
    },
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 品目種別フィルター
    filteredHinmokuShubetsuList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVIJ02')
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msteigyosho', 'msthacchakuchi', 'msthinmei', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstTeikeiList.defineHeaderPromise')
            self.headers = [
              { text: 'コースコード', value: 'teikeiKihonNo' },
              { text: 'コースNo', value: 'teikeiCourseNo' },
              { text: 'コース名称', value: 'teikeiCourseNm' },
              { text: '得意先名称', value: 'tokuisakiDisp' },
              { text: '担当営業所', value: 'tantoEigyoshoDisp' },
              { text: '客先注文番号', value: 'chumonNo' },
              { text: '商品', value: 'hinmeiDisp' },
              { text: '発地', value: 'hatsuchiDisp' },
              { text: '発時刻', value: 'hatsuchiHmsDisp' },
              { text: '経由地１', value: 'keiyuchiId1Disp' },
              { text: '経由地２', value: 'keiyuchiId2Disp' },
              { text: '経由地３', value: 'keiyuchiId3Disp' },
              { text: '経由地４', value: 'keiyuchiId4Disp' },
              { text: '経由地５', value: 'keiyuchiId5Disp' },
              { text: '着地', value: 'chakuchiDisp' },
              { text: '着時刻', value: 'chakuchiHmsDisp' },
              { text: '往復種別', value: 'ohfukuSbtNm' },
              { text: '請求車種', value: 'seikyuShashuSbtNm' },
              { text: '運賃計算方法', value: 'unchinKeisanKbnNm' },
              { text: '走行距離', value: 'yoteiSokoKyoriDisp', align: 'end' },
              { text: '走行時間', value: 'yoteiSagyoJikanDisp', align: 'center' },
              { text: '数量', value: 'juchuSuryo', align: 'end' },
              { text: '単位', value: 'unitKbnNm' },
              { text: '重量', value: 'juchuJuryo', align: 'end' },
              { text: '単価', value: 'tanka', align: 'end' },
              { text: '運賃', value: 'kihonUnchin', align: 'end' },
              { text: '運賃(高速)', value: 'hiwayPrice', align: 'end' },
              { text: '運賃(他)', value: 'unchinHokaKingaku', align: 'end' },
              { text: '保管料', value: 'hokanKingaku', align: 'end' },
              { text: '荷役料', value: 'niekiKingaku', align: 'end' },
              { text: '運賃他(非)', value: 'unchinHokaHikazei', align: 'end' },
              { text: '立替金(非)', value: 'tatekaekinHikazei', align: 'end' },
              { text: '燃料サーチャージ', value: 'nenryoSurcharge', align: 'end' },
              { text: '積込料', value: 'tsumikomiKingaku', align: 'end' },
              { text: '取卸料', value: 'torioroshiKingaku', align: 'end' },
              { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
              { text: '待機時間単価', value: 'taikiJikanTanka', align: 'end' },
              { text: '待機時間料', value: 'taikiJikanKingaku', align: 'end' },
              { text: 'その他付帯業務料', value: 'futaiGyomuKingaku', align: 'end' },
              { text: '割増対象時間', value: 'warimashiTaishoJikanDisp', align: 'center' },
              { text: '割増単価(時間)', value: 'warimashiJikanTanka', align: 'end' },
              { text: '割増金額(時間)', value: 'jikanWarimashiKingaku', align: 'end' },
              { text: '割増距離', value: 'warimashiTaishoKyoriDisp', align: 'end' },
              { text: '割増単価(距離)', value: 'warimashiKyoriTanka', align: 'end' },
              { text: '割増金額(距離)', value: 'kyoriWarimashiKingaku', align: 'end' },
              { text: '割増その他', value: 'warimashiSonotaKingaku', align: 'end' },
              { text: '請求金額合計', value: 'seikyuGokei', align: 'end' },
              { text: '傭車額', value: 'yoshaUnchin', align: 'end' },
              { text: '傭車通行料', value: 'yoshaHiwayPrice', align: 'end' },
              { text: '運行手当', value: 'sagyoinTeateKingaku1', align: 'end' },
              { text: '高速ETC', value: 'sharyoKeihiHiwayEtc', align: 'end' },
              { text: '高速現金', value: 'sharyoKeihiHiwayGenkin', align: 'end' },
              { text: 'フェリー', value: 'sharyoKeihiFerry', align: 'end' },
              { text: '請求用備考', value: 'seikyuBiko' },
              { text: '連絡用備考', value: 'renrakuBiko' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          self.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstTeikeiList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstTeikeiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstTeikeiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstTeikeiList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2mstd0460/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
                seikyuShashuSbt: self.conditions.seikyuShashuSbt
              }
            })
        },
        getSavedInputMethod: function () {
          return {
            seikyuShashuSbt: self.conditions.seikyuShashuSbt ?? ''
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      console.log('NewButton pushed')
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
      })
      this.Effects.loadComplete()
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.conditions = {
        teikeiKihonNo: '',
        teikeiCourseNo: '',
        teikeiCourseNm: '',
        tokuisakiCd: '',
        chumonNo: '',
        ohfukuSbt: '',
        seikyuShashuSbt: '',
        tantoEigyoshoCd: this.usersEigyoshoCd,
        hatsuchiCd: '',
        chakuchiCd: '',
        hinmokuSbt: '',
        hinmeiCd: ''
      }
      this.searchText = ''
      this.rows = []
    }
  }
}
